export default "__VITE_ASSET__CK624r4J__"